import { container } from "../Card/styles";

export const styles = {
    body:"my-10 md:my-0 grid justify-center bg-whithe dark:bg-fondoDark",
    input: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white",
    // container: "m-5 w-96 max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700",
    form: "space-y-1",
    label: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
    h5: "text-xl font-medium text-gray-900 dark:text-white",
    dual: "grid grid-cols-2 gap-4 justify-center",
    input_Dual:"bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white",
    button: 'mt-3 w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800',
    select: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
    div_ind: "grid grid-rows-divForm m-0",
    error: "text-red-500 text-sm",
    exito: "text-sm text-lime-400",
    div_g: "grid grid-rows-divDesImg",
    div_p: "grid grid-rows-divForm m-0",
    p: "font-medium text-gray-900 dark:text-white",
    header: "mt-5 mr-5 ml-5 mb-0 w-full max-w-sm p-4 sm:p-6 md:p-8 dark:text-white",
    logo: 'font-bungee text-5xl',
    container:'w-96 m-10 p-4 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-600 dark:border-gray-500 dark:text-white',
    info: 'grid gap-3 justify-center'
}